import React from 'react';
import { Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SelectInputTranslated from 'components/layout/forms/SelectInputTranslated';
import translations from 'services/translations/translations';

import {
  is2kAluGlazy,
  isSlidy30,
  isSlidy36,
} from 'components/configurator/types/glazingWallTypesCheck';

import {
  ALU_2K_GLAZY,
  SLIDY_30,
  SLIDY_36,
} from 'components/configurator/types/glazingWallTypes';

import handleGlassWallProperties from '../handleGlassWallProperties';

import roofProfileTypes, {
  SE0005 as ROOF_PROFILE_SE0005,
  roofProfileTypesByWallTypes,
} from '../../../../types/roofProfileTypes';

const AluGlazyRoofProfile = ({
  disableInputs,
}: {
  disableInputs?: boolean;
}): JSX.Element => {
  const wall = useSelector((state: any) => state.selectedWall.properties);
  const { t } = useTranslation([translations.glassWallProperties]);

  const disableBecauseOfWallType = is2kAluGlazy(wall);

  const getRoofProfileTypeOptions = () => {
    if (is2kAluGlazy(wall)) {
      return roofProfileTypesByWallTypes[ALU_2K_GLAZY];
    }

    if (isSlidy30(wall)) {
      return wall.thickness >= 90
        ? [ROOF_PROFILE_SE0005]
        : roofProfileTypesByWallTypes[SLIDY_30];
    }

    if (isSlidy36(wall)) {
      return roofProfileTypesByWallTypes[SLIDY_36];
    }

    return roofProfileTypes;
  };

  const name = 'aluGlazyRoofProfileType';

  return (
    <Col>
      <SelectInputTranslated
        className="edit-fields"
        disabled={disableInputs || disableBecauseOfWallType}
        id={name}
        label={t(`${translations.glassWallProperties}:fields:Roof Profile`)}
        name={name}
        onChange={handleGlassWallProperties}
        optionKeyBase={`glass-wall-field-${name}`}
        options={getRoofProfileTypeOptions()}
        required
        value={wall.aluGlazyRoofProfileType}
      />
    </Col>
  );
};

export default AluGlazyRoofProfile;
